var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 365,
    viewBox: "0 0 373 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_4524_245001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188 6L192.589 142.643L232.387 11.8437L201.454 145.019L273.75 28.9766L209.403 149.608L309.269 56.2312L215.892 156.097L336.523 91.75L220.481 164.046L353.656 133.113L222.857 172.911L359.5 177.5L222.857 182.089L353.656 221.887L220.481 190.954L336.523 263.25L215.892 198.903L309.269 298.769L209.403 205.392L273.75 326.023L201.454 209.981L232.387 343.156L192.589 212.357L188 349L183.411 212.357L143.613 343.156L174.546 209.981L102.25 326.023L166.597 205.392L66.7312 298.769L160.108 198.903L39.4766 263.25L155.519 190.954L22.3437 221.887L153.143 182.089L16.5 177.5L153.143 172.911L22.3437 133.113L155.519 164.046L39.4766 91.75L160.108 156.097L66.7312 56.2312L166.597 149.608L102.25 28.9766L174.546 145.019L143.613 11.8437L183.411 142.643L188 6Z",
    fill: "#11EADF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4524_245001",
    x: 0.5,
    y: -10,
    width: 375,
    height: 375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_4524_245001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreBg);
export default __webpack_public_path__ + "static/media/store-bg.6517e1cbed018bdd32f2149a0b35a3bb.svg";
export { ForwardRef as ReactComponent };